import React from 'react';

export const PickerList = ({ className = 'edit', data = undefined, setOpen, onDeleteMessage }) => {

    const arrayBtn = [
        { id: 0, name: "Excluir", onClick: onDeleteMessage },
        { id: 1, name: "Cancelar", onClick: () => setOpen(false) }
    ]

    return (
        <div className={className}>
            {arrayBtn.map(item => {
                return <div onClick={item.onClick} className="div-Btn">
                    {item.name}
                </div>
            })}
        </div>


    )
};

